import { Button, ButtonProps, Grid, lighten } from '@mui/material';
import styled from '@emotion/styled';
import { convertStylesToStyled } from '@/_utils/utils';

const AnimatedHaloButton = ({ children, ...props }: ButtonProps) => {
  return (
    <Grid container alignItems="center" justifyContent="center" style={{ width: 'inherit' }}>
      <AnimatingContainer>
        {!props.disabled && <div className="animated-border" />}
        <Button {...props}>{children}</Button>
      </AnimatingContainer>
    </Grid>
  );
};

export default AnimatedHaloButton;

const AnimatingContainer = styled.div`
  position: relative;
  overflow: hidden;
  padding: 1px !important;
  display: inline-block;
  border-radius: 6px;
  white-space: nowrap;

  .animated-border {
    width: 550%;
    height: 550%;
    position: absolute;
    z-index: 0;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    background: ${({ theme }) => {
      const color1 = theme.palette.mode === 'dark' ? theme.palette.primary.main : theme.palette.primary.dark;
      const color2 = theme.palette.mode === 'dark' ? theme.palette.secondary.dark : theme.palette.secondary.light;

      return `conic-gradient(transparent, transparent, transparent, ${color1}, ${color2}, transparent, transparent, transparent)`;
    }};
    animation: rotate 3s infinite linear;

    ${({ theme }) => convertStylesToStyled(theme.customOverrides?.FileIngestAnimatedBorder)}
  }

  .MuiButton-root {
    border: 1px solid ${({ theme }) => theme.palette.divider};
    border-radius: 6px;
    background-color: ${({ theme }) => theme.palette.background.paper};
    &:hover {
      background-color: ${({ theme }) => lighten(theme.palette.background.paper, 0.15)};
    }
  }
`;
